import { useQuery } from '@tanstack/react-query'
import { useClient } from '@/stores/useClient.ts'
import { CustomPriceListSummary } from '@/models/priceList.ts'

interface PriceListSelectProps {
  value: string | null
  onChange: (priceListId: string | null) => void
  defaultPriceListId?: string | null
  disabled?: boolean
}

export default function PriceListSelect({ value, onChange, defaultPriceListId, disabled }: PriceListSelectProps) {
  const { getPriceLists } = useClient()

  const { data: priceLists } = useQuery({
    queryKey: ['priceLists'],
    queryFn: async () => {
      const res = await getPriceLists()
      return res.data as CustomPriceListSummary[]
    },
  })

  return (
    <select
      className="select select-bordered w-full"
      value={value ?? ''}
      onChange={e => onChange(e.target.value || null)}
      disabled={disabled}
    >
      <option value="">Keine Preisliste</option>
      {priceLists?.map(pl => (
        <option key={pl.id} value={pl.id}>
          {pl.name}{pl.id === defaultPriceListId ? ' (Standard)' : ''}
        </option>
      ))}
    </select>
  )
}
